import * as React from 'react';

function ZoomInIcon(props) {
    return (
        <svg
        width={32}
        height={32}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 10h-2v9h-9v2h9v9h2v-9h9v-2h-9v-9Z"
            fill="#000"
        />
        </svg>
    );
}

export default ZoomInIcon;
